import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * Cursor da animacao, em segundos desde o inicio da janela.
 *
 * O avanco e por requestAnimationFrame com delta real, nao por incremento fixo:
 * assim a velocidade fica a mesma independente da taxa de quadros da maquina.
 */
export function usePlayback(durationS: number, initialSpeed = 30) {
	const [time, setTime] = useState(0)
	const [playing, setPlaying] = useState(true)
	const [speed, setSpeed] = useState(initialSpeed)
	const frame = useRef<number>(0)
	const last = useRef<number>(0)

	useEffect(() => {
		if (!playing || durationS <= 0) return
		last.current = performance.now()
		const step = (now: number) => {
			const deltaS = (now - last.current) / 1000
			last.current = now
			setTime((t) => (t + deltaS * speed) % durationS)
			frame.current = requestAnimationFrame(step)
		}
		frame.current = requestAnimationFrame(step)
		return () => cancelAnimationFrame(frame.current)
	}, [playing, durationS, speed])

	const scrub = useCallback((t: number) => {
		setTime(t)
	}, [])

	return { time, playing, speed, setSpeed, toggle: () => setPlaying((p) => !p), scrub }
}
